module.exports = __webpack_public_path__ + "static/media/1003096MF.91b9c53a.jpg";